// removed by extract-text-webpack-plugin
module.exports = {"root":"_1JudR","container":"_13NBX","number":"_BZfhT","selected":"_3LfF5","correct":"_3dWhq","incorrect":"_11Y6L"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/components/QuizNumberList/QuizNumberList.scss
// module id = 1168
// module chunks = 2